// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-image{position:relative;width:100%;height:1000px;background-position:50%;background-size:cover}.top-logo{width:258px}@media (max-width:480px){.top-logo{width:165px}.top-image{height:600px;background-position:50%;background-size:cover}.top-image img{top:18px;left:10px;height:24px;width:auto}.top-image .register-btn{margin-top:8px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
